import React from 'react'
import { Spin } from 'antd'
import { useSelector } from 'react-redux'
import CommonTable from '../../components/CommonTable'
import TrackerNote from '../../components/TrackerNote'

const PipelineDetails = () => {
  const { pipelines, isLoading } = useSelector((state) => state.pipelines)

  const columns = [
    {
      title: 'ADF Pipeline Name',
      dataIndex: 'adfPipelineName',
      key: 'adfPipelineName',
    },
    {
      title: 'Source APM ID',
      dataIndex: 'sourceApmId',
      key: 'sourceApmId',
    },
    {
      title: 'Source Server',
      dataIndex: 'sourceServer',
      key: 'sourceServer',
    },
    {
      title: 'Source Database',
      dataIndex: 'sourceDatabase',
      key: 'sourceDatabase',
    },
    {
      title: 'Destination APM ID',
      dataIndex: 'destinationApmId',
      key: 'destinationApmId',
    },
    {
      title: 'Destination Server',
      dataIndex: 'destinationServer',
      key: 'destinationServer',
    },
    {
      title: 'Destination Database',
      dataIndex: 'destinationDatabase',
      key: 'destinationDatabase',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Source Table Name',
      dataIndex: 'sourceTableName',
      key: 'sourceTableName',
    },
    {
      title: 'Destination Table Name',
      dataIndex: 'destinationTableName',
      key: 'destinationTableName',
    },
    {
      title: 'Source UAM ID',
      dataIndex: 'sourceUamId',
      key: 'sourceUamId',
    },
    {
      title: 'Destination UAM ID',
      dataIndex: 'destinationUamId',
      key: 'destinationUamId',
    },
    {
      title: 'Schedule',
      dataIndex: 'schedule',
      key: 'schedule',
    },
  ].map((col) => ({
    render: (value) => (value === null || value === undefined || value === '' ? '--' : value),
    ...col,
  }))

  const note = (
    <TrackerNote
      text="To update pipeline detail please update tracker - ADF pipeline"
      linkLabel="ADF Pipeline - All Items"
      href="https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fsites.ey.com%2Fsites%2Finapps%2FLists%2FADF%2520Pipeline%2FAllItems.aspx&data=05%7C02%7CKallol.Roy%40bd.ey.com%7Cc003e2851a714266789008df196804a7%7C5b973f9977df4bebb27daa0c70b8482c%7C0%7C0%7C639257606674079160%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=LPP7NRllXqPhG9zcM406FuSPjEYXcKX0xowgAvDR1Mk%3D&reserved=0"
    />
  )

  if (isLoading) {
    return <Spin size="large" />
  }

  if (!pipelines || pipelines.length === 0) {
    return (
      <>
        {note}
        <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>No data available</div>
      </>
    )
  }

  return (
    <>
      {note}
      <CommonTable
        columns={columns}
        dataSource={pipelines}
        rowKey="adfPipelineName"
      />
    </>
  )
}

export default PipelineDetails
